export const PO_WEIGHT_MISSING_CODE = 'PO_WEIGHT_MISSING';

export const PO_WEIGHT_ISSUE_LABELS = {
  missing_sku: 'No SKU on PO line',
  not_in_cache: 'Not in product cache — load in grid and save weight',
  weight_missing: 'Weight not recorded (0 or blank)',
  po_not_found: 'PO not found in cache',
  no_lines: 'No PO lines to check'
};

export function formatWeightIssueLine(issue) {
  const skuPart = issue?.sku ? String(issue.sku).trim() : '(no SKU)';
  const titlePart = issue?.title ? ` — ${issue.title}` : '';
  const reasonPart = PO_WEIGHT_ISSUE_LABELS[issue?.reason] || issue?.reason || 'Unknown issue';
  return `${skuPart}${titlePart} — ${reasonPart}`;
}
